const BOOLEAN = 'boolean'

export const fromIsActiveToBoolean = (isActive) =>
  typeof isActive === BOOLEAN ? isActive : !!isActive.data[0]
